export { default as DiscountedAdsSection } from "./DiscountedAdsSection";


// WEBPACK FOOTER //
// ./src/containers/ModulePage/DiscountedAdsSection/index.ts